export default __webpack_public_path__ + "static/banner-four-steps-to-funding-your-dream-wedding-34eb901c5d4b7002e4838bccb396c8f0.jpg";